import React from 'react';

import type { Grant } from '../types';

interface Props {
  grant: Grant | null;
}

export default function NylasGrantStatus({ grant }: Props) {
  if (!grant) {
    return null;
  }

  return (
    <span>
      {grant.email}
      {grant.expired && <span className="text-danger"> (Expired)</span>}
    </span>
  );
}
